module.exports = __webpack_public_path__ + "static/media/aboutus.4eeded07.jpg";